import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';

@Directive({
  selector: '[tapEffect]',
  standalone: true,
})
export class TapEffect {
  @Input() effectType: 'default' | 'list-item' = 'default';

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private b2bDeviceUtilService: B2bDeviceUtilService,
  ) {
    this.renderer.setStyle(this.el.nativeElement, 'position', 'relative'); // Ensure the parent is positioned
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden'); // Prevent overflow
  }

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
    if (this.el?.nativeElement && !this.b2bDeviceUtilService?.isServer()) {
      const ripple = this.renderer.createElement('span');

      this.setStyle();

      // default css for the ripple
      this.renderer.addClass(ripple, 'tap-ripple');

      const rect = this.el.nativeElement.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      this.renderer.setStyle(ripple, 'width', `${size}px`);
      this.renderer.setStyle(ripple, 'height', `${size}px`);
      this.renderer.setStyle(
        ripple,
        'left',
        `${event.clientX - rect.left - size / 2}px`,
      );
      this.renderer.setStyle(
        ripple,
        'top',
        `${event.clientY - rect.top - size / 2}px`,
      );

      this.renderer.appendChild(this.el.nativeElement, ripple);

      // **Force reflow to trigger animation**
      /*setTimeout(
        () => this.renderer.setStyle(ripple, 'transform', 'scale(4)'),
        0,
      );*/

      setTimeout(() => {
        this.renderer.removeChild(this.el.nativeElement, ripple);
        this.removeStyle();
      }, 600);
    }
  }

  setStyle() {
    switch (this.effectType) {
      case 'list-item':
        return;
      default:
        // Add press feedback
        this.renderer.addClass(this.el?.nativeElement, 'tap-press');
        this.renderer.addClass(this.el?.nativeElement, 'tap-press-active');
        return;
    }
  }

  removeStyle() {
    switch (this.effectType) {
      case 'list-item':
        return;
      default:
        this.renderer.removeClass(this.el.nativeElement, 'tap-press-active');
        return;
    }
  }
}
